import { useEffect } from 'react'

const FOCUSABLE = 'a[href],button:not([disabled]),textarea,input,select,[tabindex]:not([tabindex="-1"])'

// Trap focus inside `ref` while active; restore to the prior element on unmount.
export default function useFocusTrap(ref, active = true) {
  useEffect(() => {
    if (!active || typeof document === 'undefined') return undefined
    const node = ref.current
    if (!node) return undefined
    const prev = document.activeElement
    const focusables = () => Array.from(node.querySelectorAll(FOCUSABLE)).filter((el) => el.offsetParent !== null || el === document.activeElement)
    // Respect a consumer's own initial focus (e.g. an autoFocus input):
    // only pull focus into the dialog if focus isn't already inside it.
    if (!node.contains(document.activeElement)) {
      const first = focusables()[0]
      ;(first || node).focus({ preventScroll: true })
    }
    const onKey = (e) => {
      if (e.key !== 'Tab') return
      const items = focusables()
      if (!items.length) return
      const firstEl = items[0]
      const lastEl = items[items.length - 1]
      if (e.shiftKey && document.activeElement === firstEl) { e.preventDefault(); lastEl.focus() }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); firstEl.focus() }
    }
    node.addEventListener('keydown', onKey)
    return () => {
      node.removeEventListener('keydown', onKey)
      if (prev && prev.focus) prev.focus({ preventScroll: true })
    }
  }, [ref, active])
}
